<div class="title flex-row justify">
  PSD Control Line Settings
  <mat-icon matTooltip="These settings apply to the current device only" matTooltipPosition="below">
    info
  </mat-icon>
</div>

<div class="container control-lines-container">
  <div *ngIf="!loadError">
    <div *ngFor="let control of controlLines; let i = index" class="control-line-row">
      <div class="d-value flex-row align-center gap-medium">
        <span class="line-preview" [style.border-color]="colors.get(control.percent)"></span>
        D{{ control.percent }}
      </div>

      <mat-form-field>
        <mat-label>Control Value</mat-label>
        <measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$ | async)"
          [(ngModel)]="control.value" (ngModelChange)="checkForChanges()" [disabled]="saving">
        </measurement-input>
      </mat-form-field>

      <mat-icon class="list-edit-icon" (click)="removeControlLine(i)"
        [class.disabled]="saving" [attr.aria-label]="'Remove D' + control.percent + ' control line'">
        cancel
      </mat-icon>
    </div>

    <hr *ngIf="controlLines.length" />

    <div class="control-line-row new-control-line">
      <mat-form-field appearance="outline">
        <mat-label>D-value</mat-label>
        <mat-select [(ngModel)]="newControlLine.percent" [disabled]="saving">
          <mat-option *ngFor="let percent of percents" [value]="percent"
            [disabled]="!isPercentAvailable(percent)">D{{ percent }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Control Value</mat-label>
        <measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$ | async)"
          [(ngModel)]="newControlLine.value" [disabled]="saving">
        </measurement-input>
      </mat-form-field>

      <mat-icon class="list-edit-icon" (click)="canAddControlLine() && addControlLine()"
        [class.disabled]="!canAddControlLine()" aria-label="Add control line">
        add_circle_outline
      </mat-icon>
    </div>
  </div>

  <p *ngIf="loadError" class="error-message" role="alert">{{ loadError }}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()"
    [disabled]="!canSave()">
    {{ saving ? 'Saving…' : 'Save' }}
  </button>
</div>
